import React from "react";
import { connect } from "react-redux";
import SectionLoading from '../common/SectionLoading';
import SectionLoadingError from '../common/SectionLoadingError';
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class PrescriptionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showAsInvalid: false };
        this.selectPrescriptionFromProps = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PrescriptionList.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    isValid() {
        const { orderRefill } = this.props;
        const isValid = orderRefill && typeof orderRefill.selectedRxCount !== 'undefined' && orderRefill.selectedRxCount > 0;
        return isValid;
    }

    onGoNext(success) {
        if (!success) {
            this.setState({ showAsInvalid: true });
        }
        if (this.props.onGoNext) {
            this.props.onGoNext(success);
        }
    }

    updateByIdScrollToView(id) {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({
                    behavior: 'smooth'
                });
            }, 100);
        }
    }

    render() {
        const { orderRefill, currentPharmacyUser, activeRxNumber, activeStoreNumber } = this.props;

        var defaultPharmacyWiseRefillsLists = orderRefill && orderRefill.list && orderRefill.list.PrescriptionRefills && orderRefill.list.PrescriptionRefills.sort(function (a, b) {
            return b.PharmacyDetail.IsDefault - a.PharmacyDetail.IsDefault;
        });

        var proxyUser = currentPharmacyUser;//once pharmacy proxy is wired, assign the appropriate pharmacy proxy name.
        proxyUser = (proxyUser && proxyUser.firstName) ? proxyUser.firstName + ' has' : 'You have';
        let countAvailableRefills = 0;
        let countRenewalRefills = 0;

        var orderRefillElements = defaultPharmacyWiseRefillsLists &&
            defaultPharmacyWiseRefillsLists.map((item, index) => {
                var isReadonly = orderRefill.selectedRxCount > 0 && orderRefill.storeNumberTargetting !== item.PharmacyDetail.StoreNumber;
                if (item.AvailableRefills.length !== 0) {
                    countAvailableRefills++; //if there are any AvailableRefills, we will increment countAvailableRefills
                }
                if (item.RenewalRefills.length !== 0) {
                    countRenewalRefills++;
                }

                const allRefills = item && item.RenewalRefills.length > 0 ? item.AvailableRefills.concat(item.RenewalRefills) : item.AvailableRefills;

                if (activeRxNumber && activeStoreNumber && !this.selectPrescriptionFromProps) {
                    for (let i = 0; i < allRefills.length; i++) {
                        if (activeStoreNumber === item.PharmacyDetail.StoreNumber && allRefills[i].RxNumber === activeRxNumber) {
                            this.props.onRxChecked(true, allRefills[i], item.PharmacyDetail.StoreNumber);
                            this.updateByIdScrollToView(index + "AvailableRefills" + i);
                            this.selectPrescriptionFromProps = true;
                            break;
                        }
                    }
                }

            const pharmacyName = (item && item.PharmacyDetail && item.PharmacyDetail.Name) ? item.PharmacyDetail.Name : "";
            const pharmacyAddress = (item && item.PharmacyDetail && item.PharmacyDetail.Address && typeof item.PharmacyDetail.Address.City !== 'undefined' && item.PharmacyDetail.Address.City) ? item.PharmacyDetail.Address.City : "";

            return (
                allRefills && allRefills.length > 0 ?
                        <div key={index} className="row select-prescriptions-rx" style={this.props.style}>
                            <div className="col-12">
                                <div className="row">
                                    <div className={"col-12 list-item-col__heading not-linked" + (isReadonly ? " disabled-style" : "")}>
                                    {(item && item.PharmacyDetail && item.PharmacyDetail.IsDefault && (pharmacyName || pharmacyAddress)) ? "Your Pharmacy - " : ""}
                                    {(pharmacyName || pharmacyAddress) ? pharmacyName + " - " + pharmacyAddress : "BSW Pharmacy"}
                                    {(item && item.PharmacyDetail && item.PharmacyDetail.IsPharmacyActive === false) ? " - Closed" : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                            {allRefills.map((allRx, i) => {
                                    return (
                                    <div className="row" key={index + "AvailableRefills" + i} id={index + "AvailableRefills" + i}>
                                            <label htmlFor={"rx" + allRx.RxNumber} className={"col-12 list-item-col not-linked" + (isReadonly ? " disabled-style" : "")}>
                                                <div className="row">
                                                    <div className="col-12 col-sm-5 col-xl-6">
                                                        <div className="checkbox-container select-rx-name">
                                                            {isReadonly ?
                                                                <input type="checkbox" disabled checked={false} /> :
                                                                <input type="checkbox" id={"rx" + allRx.RxNumber}
                                                                    checked={(typeof allRx.selected !== 'undefined' && allRx.selected) || (activeStoreNumber === item.PharmacyDetail.StoreNumber && activeRxNumber === item.PharmacyDetail.RxNumber)}
                                                                    value={allRx.RxNumber + '-' + item.PharmacyDetail.StoreNumber + '-' + "" + '-' + allRx.RxDrugName}
                                                                    onChange={e => {
                                                                        this.props.onRxChecked(e.target.checked, allRx, item.PharmacyDetail.StoreNumber, index);
                                                                        if (this.state.showAsInvalid) {
                                                                            this.setState({ showAsInvalid: false });
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                            <span className="checkmark" />
                                                            <span className="checkbox-label">{allRx.RxDrugName}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-3 col-xl-2">
                                                        <div className="select-rx-no">RX No. {allRx.RxNumber}</div>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-xl-4">
                                                        <div className="select-rx-refills">{allRx.Refills} Refills until {allRx.RxExpiryDate}</div>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div> : null
                );
            });

        return (
            <div style={this.props.style}>
                {this.props.orderRefill && (countAvailableRefills > 0 || countRenewalRefills > 0)
                            ? <div className="select-prescriptions-container">
                                {orderRefillElements}
                                {this.state.showAsInvalid &&
                                    <div className="row">
                                        <div className="col-12 text-center validation-error-container">
                                            <div className="error-msg">Please select a prescription.</div>
                                        </div>
                                    </div>
                                }
                    </div>
                    : null
                }
            </div>
        );

        /*<div className="col-12">
                    {
                        item.RenewalRefills.map((renewRx, i) => {
                            var isCheckedRenew = this.state.RxOrderRefillData && this.state.RxOrderRefillData.SubmitOrderItems[0] ? (this.state.RxOrderRefillData.SubmitOrderItems[0].RxDetails.find(x => x.RxNumber == renewRx.RxNumber) && (this.state.RxOrderRefillData.SubmitOrderItems[0]["StoreNumber"] === item.PharmacyDetail.StoreNumber)) ? "true" : "false" : "false";
                            
                            return (
                                <div className={!isReadonly ? "row list-item-row" : "row list-item-row disableddiv"} key={index + "RenewalRefills" + i}>
                                    <div className="col-12 col-sm-1">
                                        <label className="checkbox-container">
                                            {isReadonly ?
                                                <input type="checkbox" disabled value={renewRx.RxNumber + '-' + item.PharmacyDetail.StoreNumber + '-' + "RENEW REFILLS" + '-' + renewRx.RxDrugName} onChange={(e) => this.handleInputChange('Generic', e)} />
                                                : <input type="checkbox" checked={isCheckedRenew === "true" ? true : false} value={renewRx.RxNumber + '-' + item.PharmacyDetail.StoreNumber + '-' + "RENEW REFILLS" + '-' + renewRx.RxDrugName} onChange={(e) => this.handleInputChange('Generic', e)} />
                                            }
                                            <span className="checkmark" />
                                        </label>
                                    </div>
                                    <div className="col-12 col-sm-3">{renewRx.RxDrugName}</div>
                                    <div className="col-12 col-sm-3">RX No. {renewRx.RxNumber}</div>
                                    <div className="col-12 col-sm-5">{renewRx.Refills} Refills unitl {renewRx.RxExpiryDate}</div>
                                </div>
                            )
                        })
                    }
            </div>*/
    }

}

const mapStateToProps = (state) => {
    return {
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps, null, null, { withRef: true })(PrescriptionList);